import { MdxDiv } from '@features/mdx/MdxDiv';
import { LanguageEnum } from '@project-types/LanguageEnum';
import { MdxPageArticleIds } from '@features/mdx/MdxPageArticleIds';
import veterinaryCat from '@assets/images/veterinary-cat.webp';



const articleIds: MdxPageArticleIds = {
	[LanguageEnum.CZ]: '0989a1b6-5bd4-4baa-a9c8-8a45ec7af521',
	[LanguageEnum.SK]: '0989a1b6-5bd4-4baa-a9c8-8a45ec7af521',
	default: '0989a1b6-5bd4-4baa-a9c8-8a45ec7af521'
}


export const Veterinary = () => {

	return (
		<div className='veterinary'>
			
			<div className='veterinary-photo'>
				<img src={veterinaryCat} alt='veterinary-photo-dog' />
			</div>

			<MdxDiv className='veterinary-text' articleIds={articleIds}>
			</MdxDiv>
		
		</div>
	)
}